import { render, staticRenderFns } from "./CUDCategorySubcategoryForm.vue?vue&type=template&id=0692273a"
import script from "./CUDCategorySubcategoryForm.vue?vue&type=script&lang=js"
export * from "./CUDCategorySubcategoryForm.vue?vue&type=script&lang=js"
import style0 from "./CUDCategorySubcategoryForm.vue?vue&type=style&index=0&id=0692273a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports